import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const updateVendorEmailQuery = async ({ vendorId, purchaseOrderId, lineItemId }) => {
  const payload = {
    vendorId,
    purchaseOrderId,
    ...(lineItemId && { lineItemId })
  };

  const response = await axios.post(apiurl?.updateVendorEmail, payload);
  return response.data;
};

const updateVendorEmail = () => {
  const queryClient = useQueryClient();

  return useMutation(updateVendorEmailQuery, {
    onSuccess: () => {
      queryClient.invalidateQueries('getPO');
    }
  });
};

export default updateVendorEmail;
